import { Component, OnInit } from '@angular/core';
import { Navigator } from 'src/app/services/routing/navigator';

@Component({
  selector: 'app-signup-options',
  templateUrl: './signup-options.component.html',
  styleUrls: ['./signup-options.component.scss'],
})
export class SignupOptionsComponent implements OnInit {

  constructor(
    private navigator: Navigator, 
  ) { }

  ngOnInit() {

  }

  navigateTo(page: string,data) {
		return this.navigator.navigateTo(page,'',data);
	}

}
